export enum ForecastTypeOption {
  Fixed = 'fixed',
  Rolling = 'rolling'
}
export type ForecastKindOption = 'budget' | 'scenario';
export const FIXED_FORECAST_CHOICES = ['1', '2', '3', '4', '5', '6'];
export const ROLLING_FORECAST_CHOICES = ['FY+1', 'FY+2', 'FY+3'];
export interface ForecastFormError {
  id: string;
  message: string;
}
export type ForecastFormErrors = Record<string, ForecastFormError>;

export enum ForecastFormElementIds {
  Name = 'forecast-name',
  From = 'forecast-from',
  Type = 'forecast-type',
  Duration = 'forecast-duration',
  PreviousActuals = 'forecast-previous-actuals',
  SourceForecast = 'forecast-datasource-forecast',
  Datasource = 'forecast-datasource'
}
